const t = (a, e) => a === "toast" ? e ? "40px" : { base: 4, md: 6 } : e ? { base: "48px", md: "60px" } : { base: 4, md: 6 };
export {
  t as getPaddingRightValue
};
